import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/global.css'
import './styles/responsive.css'
import './styles/modals.css'
import { initializeAnalytics } from './services/analytics'

// Инициализация Google Analytics
initializeAnalytics()

// Регистрация Service Worker для офлайн-режима (только в production)
// В Telegram WebView не регистрируем SW — избегаем ReactCurrentBatchConfig (смешивание кэша)
const isTelegramWebView = typeof window !== 'undefined' && window.Telegram?.WebApp;
if ('serviceWorker' in navigator && import.meta.env.PROD && !isTelegramWebView) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registered:', registration.scope);
        
        // Проверка обновлений каждый час
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });
} else if ('serviceWorker' in navigator && import.meta.env.DEV) {
  // В dev режиме отключаем Service Worker для лучшей работы HMR
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
      console.log('🔧 Service Worker unregistered for development');
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

